import client from "@/common/client"
import type { IRequest } from "@/common/interfaces"

interface IUpdateStatus {
    id: number
    newStatus: string
}

const requestRepository = {
    getAll: (): Promise<IRequest[]> => client.get("/api/recruiter/requests"),
    addRequest: (message: string): Promise<IRequest[]> =>
        client.post("/api/recruiter/requests", { message }),
    updateStatus: (data: IUpdateStatus): Promise<IRequest[]> =>
        client.patch("/api/recruiter/requests", data)
}

export default requestRepository
